import { useMutation, useQueryClient } from "@tanstack/react-query";
import { showErrorAlert } from "../../utils/showErrorAlert";
import { showSuccessToast } from "../../utils/showToastAlert";

/**
 * @param {object} deps
 * @param {(url: string, options: any) => Promise<any>} deps.callApiWithWorker
 * @param {(key: string) => string} deps.t
 */
export function usePutDistribution({ callApiWithWorker, t }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["updateDistribution"],

    mutationFn: async ({ id, payload }) => {
      if (!id) {
        throw new Error("Distribution id is required for update");
      }

      return callApiWithWorker(`/distributions/${id}`, {
        method: "PUT",
        body: payload,
      });
    },

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["distributions"] });

      showSuccessToast(
        t(
          "updateSubMessage",
          "La distribución se ha actualizado correctamente.",
        ),
        {
          title: t("updateMessage", "Distribución actualizada"),
        },
      );
    },

    onError: (error) => {
      console.error("Error al actualizar la distribución:", error);
      showErrorAlert(error);
    },
  });
}
